import { Navigate } from 'react-router-dom';
import ROUTES from '../../constants/routes';

/**
 * Wrapper para rutas públicas (login, register, etc.)
 *
 * Redirige a home si el usuario ya está autenticado.
 *
 * @param {Object} props - Propiedades del componente
 * @param {React.ReactNode} props.children - Componente a renderizar si no autenticado
 * @param {boolean} props.isAuthenticated - Estado de autenticación
 * @returns {JSX.Element}
 */
function PublicRoute({ children, isAuthenticated }) {
  return isAuthenticated ? <Navigate to={ROUTES.HOME} replace /> : children;
}

export default PublicRoute;
